import { AnimatePresence, motion } from 'framer-motion'
import BackgroundImage from '@/assets/background-image.png'
import BotTestStartImage from '@/assets/bot-test-start-image.png'
import { Column, Row, Text } from '@/components/core'

const TestStartMessage = () => {
  return (
    <AnimatePresence>
      <motion.div
        key="test-start-message"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="flex w-full flex-col space-y-10 pb-8"
      >
        <Row className="h-px w-full justify-center bg-white/20">
          <Row className="h-6 w-36 items-center justify-center self-center rounded-full bg-electric-indigo-300">
            <Text.Translated
              transform="uppercase"
              fontWeight="bold"
              className="text-[10px] text-white"
              translationKey="test_start_test_start_message"
            />
          </Row>
        </Row>
        <Row className="relative w-full space-x-5 overflow-hidden rounded-2xl rounded-tl-none bg-white md:h-full md:min-h-[200px]">
          <Column className="absolute left-0 z-0 h-full w-[8%] overflow-hidden bg-electric-indigo-50">
            <img
              src={BackgroundImage}
              alt="background-image"
              className="h-full w-full overflow-hidden rounded-full object-cover"
            />
          </Column>
          <img
            src={BotTestStartImage}
            alt="bot-image"
            className=" absolute bottom-0 left-[-10px] h-[55%] w-auto overflow-hidden object-contain md:h-[90%] "
          />
          <Column className="w-full justify-center pl-[25%]">
            <Text className="x-3 max-md:py-2 md:max-w-[484px]">
              <Text>
                <Text.Translated
                  className="inline max-md:text-sm"
                  color="600"
                  fontWeight="bold"
                  translationKey="test_start_complete_message_test_start_message_well_done"
                />{' '}
                <Text.Translated
                  className="inline max-md:text-sm"
                  color="600"
                  translationKey="test_start_complete_message_test_start_message_start_over"
                />{' '}
                <Text.Translated
                  className="inline max-md:text-sm"
                  color="600"
                  fontWeight="bold"
                  translationKey="test_start_complete_message_test_start_message_fluency_test"
                />
              </Text>
              <Text.Translated
                className="max-md:text-sm"
                color="600"
                translationKey="remember_speak_maximum_test_start_message"
              />
            </Text>
          </Column>
        </Row>
      </motion.div>
    </AnimatePresence>
  )
}

export default TestStartMessage
